import { useState, useEffect } from 'react';

export const useIsParentVisible = (
  parentRef: React.RefObject<HTMLElement | null>
): boolean => {
  const [isParentVisible, setIsParentVisible] = useState(false);
  const onParentIntersection: IntersectionObserverCallback = (entries) => {
    const entry = entries[0];

    setIsParentVisible(!!entry?.isIntersecting);
  };

  useEffect(() => {
    const parentObserver = new IntersectionObserver(onParentIntersection, {
      rootMargin: '0px 0px -45px 0px',
      root: document,
    });

    if (parentRef?.current) {
      parentObserver.observe(parentRef.current);
    }

    return () => {
      parentObserver.disconnect();
    };
  }, [parentRef]);

  return isParentVisible;
};

export const useIsContextMenuVisible = (
  contextMenuRef: React.RefObject<HTMLElement | null>
): boolean => {
  const [isContextMenuVisible, setIsContextMenuVisible] = useState(true);
  const onContextMenuIntersection: IntersectionObserverCallback = (entries) => {
    const entry = entries[0];
    setIsContextMenuVisible(!entry?.isIntersecting);
  };

  useEffect(() => {
    const contextMenuObserver = new IntersectionObserver(
      onContextMenuIntersection,
      {
        rootMargin: '0px 0px -60px 0px',
        root: document,
      }
    );

    if (contextMenuRef.current) {
      contextMenuObserver.observe(contextMenuRef.current);
    }

    return () => {
      contextMenuObserver.disconnect();
    };
  }, [contextMenuRef]);

  return isContextMenuVisible;
};
